var map = {
	"./1.png": 3241,
	"./10.png": 6498,
	"./11.png": 5393,
	"./12.png": 7658,
	"./2.png": 9899,
	"./3.png": 107,
	"./4.png": 9405,
	"./5.png": 6297,
	"./6.png": 9688,
	"./7.png": 4587,
	"./8.png": 955,
	"./9.png": 4941
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2597;